module.exports = __webpack_public_path__ + "img/profile_teo_ft1.fe138490.jpg";